export const DATETIMEFORMART = 'YYYY-MM-DDTHH:mm';

export interface EventRequest {
  placeEmailAddress?: string;
  subject: string;
  startTime: string;
  endTime: string;
  reminderMinutesBeforeStart?: number | null;
  attendees?: AttendeeInformation[];
  isOnPrem: boolean;
  showAs?: number;
  recurrencePattern?: RecurrencePattern;
  timeZoneInfo?: string;
  isOnlineMeeting?: boolean;
  bookingType?:BookingTypeValue;
}

export interface CalendarEvent {
  id: string;
  startTime: string;
  endTime: string;
  subject: string;
  isOrganizer: boolean;
  showAs?: number;
  reminderMinutesBeforeStart?: number | null;
  place: {
    address: {
      street: string;
      zip: string;
      city: string;
      floor?: string;
      country: string;
      floorNumber: Number;
    };
    displayName: string;
    type: string;
    emailAddress?: string;
    avatar?: string;
    capacity?: any;
    floorMapId?: string;
  };
  resourceStatus: string;
  attendees: AttendeeInformation[];
  organizer: OrganizerInformation;
  seriesMasterId: string;
  isLoading?: boolean;
  isOnlineMeeting?: boolean;
  recurrencePattern: RecurrencePattern;
  onlineMeetingUrl?: string;
  isNewEvent: boolean;
  editMasterEvent: boolean;
  isResourcelessEvent?: boolean;
  isCancelled?: boolean;
  attachments?: any[];
  hasDescription?: boolean;
  hasAttachments?: boolean;
  description?: string;
  isExpired?: boolean;
  bookingType?:BookingTypeValue;
}
export interface RecurrencePattern {
  startTime: Date;
  endTime: Date;
  startDate: Date;
  endDate: Date;
  accuranceDays: number[];
  interval: number;
  accuranceType: string;
  dayOfMonth?: number;
  month?: number;
  index?: string;
}
export interface Place {
  isLoading?: boolean;
  type: string;
  displayName: string;
  avatar: any;
  isAvailable: boolean;
  capacity?: number;
  availableSpace?: number;
  tag: string;
  emailAddress: string;
  isFav: boolean;
  favIndexOrdering: number;
  address: {
    country: any;
    street: string;
    zip: string;
    city: string;
    floor?: string;
    floorNumber: number;
  };
  isOnPrem: boolean;
  pending?: boolean;
  floorMapId?: string;
  showcaseImages: string[];
  isFirstAiderPresent?: boolean;
}

export interface SearchRequestNew {
  startTime: Date;
  endTime: Date;
  recurrencePattern?: RecurrencePattern;
  isAllDay?: boolean;
}
export interface SearchRequest {
  // startTime: string;
  // endTime: string;
  // recurrencePattern?: RecurrencePattern;
  // Legacy properties for backward compatibility
  startTimeUTC?: string;
  endTimeUTC?: string;
  type?: string;
  localStartTimeValue?: any;
  localEndTimeValue?: any;
  isAllDay?: boolean;
  recurrenceType?: string;
  repeatEvery?: number;
  recurrenceEndDate?: string;
  recurrenceStartDate?: string;
  dayOfMonthlyMeeting?: number;
  selectedWeekDays?: number[];
}

export interface UserInformation {
  avatar: string;
  displayName: string;
  jobTitle: string;
  department: string;
  companyName: string;
  surname: string;
  givenName: string;
  mobilePhone: string;
  userPrincipalName: string;
  mail: string; // the email of the user, may be different from upn
  licenseExperation: string;
  workingHours: WorkingHours;
  vehicleNumber: string;
  hasTeamsLicense: boolean;
  microsoftUserId: string;
}
export interface WorkingHours {
  daysOfWeek: number[];
  startTime: {
    hour: number;
    minute: number;
    dateTime: string;
  };
  endTime: {
    hour: number;
    minute: number;
    dateTime: string;
  };
}

export interface MeetingStepperDetails {
  startTime: string;
  endTime: string;
  category: string;
  capacity: number;
  participants: AttendeeInformation[];
  isOnlineMeeting: boolean;
  subject: string;
  reminder: number;
  prioritizeFavoritePlaces: boolean;
  acceptGreaterCapacity: boolean;
  acceptSmallerCapacity: boolean;
}

export enum MeetingStepperErrorCodes {
  CapacityNotFound = 1000,
  MicroSoftBookError = 1001,
  EWSBookError = 1002,
  ProccessEnd = 1003,
}

export interface AttendeeInformation {
  firstName: string;
  lastName: string;
  userPrincipalName: string;
  isOptional?: boolean;
  isAvailable?: boolean;
  response: string;
  isLoading?: boolean;
}

export interface BookingPeriod {
  startTime: string;
  selectedStartTime: string;
  endTime: string;
  selectedEndTime: string;
  startTimeMinutes: number;
  endTimeMinutes: number;
  selectedTimesRange: any;
}

export interface FloorPlanInfo {
  country: string;
  city: string;
  street: string;
  floor: number;
  floorLabel: string;
  _id: string;
  floorMapImage: any;
  lastUpdated: string;
  organisationId: string;
  triggerringUPN?: string;
}

export interface OrganizerInformation {
  name: string;
  emailAddress: string;
}

export interface FeedbackInterface {
  age: string;
  bookingFlow: string;
  comment: string;
  design: string;
  filteringFlow: string;
  os: string;
  overall: string;
  profession: string;
  rating: string;
  suggestion: string;
  usability: string;
  creationDate: string;
  version: string;
  appName: string;
}
/*export interface AccountContactTicket {
    firstName: string;
    lastName: string;
    companyName: string;
    email: string;
    phoneNumber: string;
    language: string
}*/
export interface UserPreferences {
  userSettings: UserSettings;
  userFavoriteMaps: string[];
}
export interface UserSettings {
  bookingStatus: number;
  // defaultMeetingDuration: number;
  weatherLocation?: string;
  useLocationForWeather?: boolean;
}

export interface PlaceAvatar {
  upn: string;
  avatar: string;
}
export interface PlaceAvatarStorage {
  avatars: PlaceAvatar[];
  savedAt: string;
}

export interface OnboardingSlide {
  image: string;
  header: string;
  discription: Array<string>;
}

export interface FilterCriteria {
  country: string;
  city: string;
  street: string;
  floor: string;
  floorNumber: string;
  tag: string;
}
export interface NewsArticle {
  createdAt: string;
  createdBy: string;
  headline: string;
  order: string;
  organizationId: string;
  symbol: string;
  text: string;
  updatedAt: string;
  updatedBy: string;
  _id: string;
  publishDate: Date;
  expiryDate: Date;
}

export interface WeatherData {
  name: string;
  region: string;
  country: string;
  tempC: number;
  tempF: number;
  text: string;
  icon: string;
  windKph: number;
  windMph: number;
  humidity: number;
}

export interface CitySuggestion {
  name: string;
  country: string;
  region: string;
}

export const reminderMinutes = [
  { text: 'reminderSelect.without', value: null },
  { text: 'reminderSelect.atEventStart', value: 0 },
  { text: 'reminderSelect.fiveMinutes', value: 5 },
  { text: 'reminderSelect.tenMinutes', value: 10 },
  { text: 'reminderSelect.fithteenMinutes', value: 15 },
  { text: 'reminderSelect.thirtyMinutes', value: 30 },
  { text: 'reminderSelect.oneHour', value: 60 },
  { text: 'reminderSelect.twoHours', value: 120 },
  { text: 'reminderSelect.oneDay', value: 1440 },
  { text: 'reminderSelect.oneWeek', value: 241920 },
];

export const showAsOptions = [
  { text: 'showAsOptions.Free', value: 'Free', index: 1 },
  {
    text: 'showAsOptions.WorkingElsewhere',
    value: 'WorkingElsewhere',
    index: 5,
  },
  { text: 'showAsOptions.Tentative', value: 'Tentative', index: 2 },
  { text: 'showAsOptions.Busy', value: 'Busy', index: 3 },
  { text: 'showAsOptions.OutOfOffice', value: 'Oof', index: 4 },
];

export const meetingDurationOptions = [5, 15, 30, 60, 90, 120];

export interface FirstAider {
  groupMember: {
    firstName?: string;
    lastName?: string;
    upn: string;
    businessPhone?: string;
    mobilPhone?: string;
  };
  location?: string | null;
  locationAsPlace?: Place | null;
  locationToDisplay?: string;
  canCall?: boolean;
}

export interface OrganisationInformation {
  brandLogoPath: string;
}

export interface MsProblemReport {
  upn: string;
  userId: string;
  time: string;
}

export enum BookingTypeValue
{
    QuickBooking = 'QuickBooking',
    FilterBooking = 'FilterBooking',
    SliderBooking = 'SliderBooking',
    WorkHourBooking = 'WorkHourBooking',
}

export const UnleashFeatureFlags = {
  SEARCH_POPOVER_WORKING_HOURS: 'sparo.book-using.working.hours',
  DASHBOARD_LOGO_WIDGET: 'sparo.dashboard-add.logo.widget',
  ONPREMIS_LATER_BOOKING: 'sparo.onpremisbooking-enable-onprem-booking',
  DASHBOARD_WEATHER_SYNC_WITH_CURRENT_LOCATION: 'sparo.dashboard.weather-sync.with.current.location',
  PLACE_COMPONENT_WORKING_HOURS: 'sparo.workinghours-add.to.book.button',
  MY_BOOKINGS_ITEM_FORWARD_EVENT: 'sparo.invitation-add.forward.option'
}
export interface ForwardEventRequest {
  eventId: string;
  comment: string;
  toRecipients: string[];
}